import createIcon from '../../createIcon';

/**
 * @component @name WhereToVote
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkMxNS44NiAyIDE5IDUuMTQgMTkgOUMxOSAxNC4yNSAxMiAyMiAxMiAyMkMxMiAyMiA1IDE0LjI1IDUgOUM1IDUuMTQgOC4xNCAyIDEyIDJaTTEwLjQ3IDE0TDE3IDcuNDFMMTUuNiA2TDEwLjQ3IDExLjE4TDguNCA5LjA5TDcgMTAuNUwxMC40NyAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WhereToVote = createIcon('WhereToVote', [
  [
    'path',
    {
      d: 'M12 2C15.86 2 19 5.14 19 9C19 14.25 12 22 12 22C12 22 5 14.25 5 9C5 5.14 8.14 2 12 2ZM10.47 14L17 7.41L15.6 6L10.47 11.18L8.4 9.09L7 10.5L10.47 14Z',
      key: 'v1a4sn',
    },
  ],
]);

export default WhereToVote;
